import mrpStyles from './../mrp.json'

const headText = {
  paragraphType: 'Heading',
  paragraphTagName: 'h4',
  paragraphName: 'A1',
  letterSpacing: 0,
  marginLeft: 0,
  marginTop: 2,
  color: mrpStyles.colors.PrimaryBlack
}

const preTitle = {
  borderTopColor: mrpStyles.colors.SecondaryGreySteel,
  letterSpacing: 0,
  color: mrpStyles.colors.PrimaryBlack,
  textAlign: 'center',
  textAlignMedium: 'left',
  paragraphType: 'Heading',
  paragraphTagName: 'h4',
  paragraphName: 'A1',
  fontSize: 16,
  fontSizeMedium: 14,
  fontSizeLarge: 14,
  fontSizeXLarge: 16
}

const title = {
  color: mrpStyles.colors.PrimaryBlack,
  fontSize: 80,
  fontSizeMedium: 64,
  fontSizeLarge: 64,
  fontSizeXLarge: 100,
  lineHeight: '88px',
  lineHeightMedium: '72px',
  lineHeightLarge: '72px',
  lineHeightXLarge: '108px',
  fontSizeAlphaNum: 32,  
  lineHeightAlphaNum: '40px',
  textAlign: 'center',
  textAlignMedium: 'left',
  marginTopMultiplier: 1,
  marginTopMultiplierMedium: 1,
  marginTopMultiplierLarge: 1,
  marginTopMultiplierXLarge: 1.5,
  marginBottomMultiplier: 3,
  marginBottomMultiplierMedium: 2.5,
  marginBottomMultiplierLarge: 2.5,
  marginBottomMultiplierXLarge: 3.5,
  marginTopMedium: 0,
  paragraphType: 'Heading',
  paragraphTagName: 'h3',
  paragraphName: 'B1'
}

const text = {
  textAlign: 'center',
  textAlignMedium: 'left',
  fontSize: 16,
  fontSizeMedium: 16,
  fontSizeLarge: 16,
  fontSizeXLarge: 16,
  marginBottom: 4
}

const marginMultipliers = {
  desktopLeft: 4,
  desktopRight: 5,
  tabletLeft: 4,
  tabletRight: 5,
  mobileLeft: 4,
  mobileRight: 4,
  bottomDivider: 0,
  arrowRight: 6.5,
  arrowRightLarge: 7.5,
  arrowLeft: 7,
  arrowLeftLarge: 7.5
}

const paddingMultipliers = {
  mobileLeft: 0,
  mogileRight: 0,
  mobileBorderTop: 2,
  tabletBorderTop: 2,
  desktopBorderTop: 8
}

const heights = {
  mobile: 565,
  medium: 290,
  large: 270,
  xLarge: 350
}

const pids = {
  shadow: true,
  pidPadding: true,
  defaultWidth: 211,
  defaultHeight: 271,
  skeletonBottonMargin: 3,
  imageAspectRatio: 1.044
}

// tier expansion

const tierHeights = {
  mobile: '545px',
  medium: '380px',
  large: '30vw',
  xLarge: '428px'
}

const tierGredient = {
  eip: 'linear-gradient(125deg, #031F27 29.56%, #053847 123.82%)',
  eipplatinum: 'linear-gradient(127deg, #303138 37.84%, #67696e 126.6%)'
}

const tierOuterOverrides = {
  margin: 0,
  padding: '24px'
}

// tier expansion end

export default {
  preTitle,
  title,
  text,
  marginMultipliers,
  paddingMultipliers,
  heights,
  pids,
  headText,
  tierHeights,
  tierGredient,
  tierOuterOverrides
}
